// extracted by mini-css-extract-plugin
export default {"input":"AddGradeForm_input__J019E"};